// Some article extractors emit pipe-delimited data rows without the header
// separator required by Markdown. Supply an empty header for the parser;
// the article table renderer omits that empty header from the document.
export const normalizeArticleMarkdownTables = markdown => {
    const lines = String(markdown || '').split('\n');
    const result = [];
    let fence = null;

    const getCells = line => {
        if (/^(?: {4}|\t)/.test(line)) return null;
        const trimmed = line.trim();
        if (!trimmed.startsWith('|') || !trimmed.endsWith('|')) return null;
        // Escaped pipes belong to the cell, rather than dividing columns.
        const cells = trimmed.slice(1, -1).split(/(?<!\\)\|/);
        return cells.length >= 2 ? cells : null;
    };
    const isSeparator = line => {
        const cells = String(line || '').trim().replace(/^\||\|$/g, '').split('|');
        return cells.length >= 2 && cells.every(cell => /^\s*:?-+:?\s*$/.test(cell));
    };

    for (let index = 0; index < lines.length; index += 1) {
        const line = lines[index];
        const marker = line.match(/^ {0,3}(`{3,}|~{3,})/);
        if (marker) {
            if (!fence) fence = marker[1];
            else if (marker[1][0] === fence[0] && marker[1].length >= fence.length && /^\s*$/.test(line.slice(marker[0].length))) fence = null;
            result.push(line);
            continue;
        }

        const cells = !fence && getCells(line);
        const startsBlock = index === 0 || !lines[index - 1].trim();
        if (cells && startsBlock && !isSeparator(line) && !isSeparator(lines[index + 1])) {
            result.push(`| ${cells.map(() => ' ').join(' | ')} |`);
            result.push(`| ${cells.map(() => '---').join(' | ')} |`);
        }
        result.push(line);
    }

    return result.join('\n');
};
